<template>
  <div class="album-card" ref="target">
    <slot name="default" :random-photo-url="randomPhotoUrl">
      <nuxt-link :to="{ name: 'slug', params: { slug: album.slug } }">
        <img class="album-card-photo" :src="randomPhotoUrl" loading="lazy" />

        <div class="p-5 space-y-2">
          <div>
            <div class="album-card-title">
              {{ album.title }} ({{ album.photoCount + album.videoCount }})
            </div>
            <div>{{ dateRangeFormatted }}</div>
          </div>
        </div>
      </nuxt-link>
    </slot>
  </div>
</template>

<script lang="ts" setup>
import type { Album } from "~/api";

const target: Ref<HTMLDivElement | undefined> = ref();

// const isVisible = useElementVisibility(target);
const isVisibleOnce = useElementVisibilityOnce(target);

const props = defineProps<{ album: Album }>();

const randomPhotoUrl = computed(() => {
  if (isVisibleOnce.value) {
    const size = 600;
    const index = randomInteger(0, props.album.photoCount - 1);
    return `/api/albums/${props.album.slug}/${index}/${size}/photo.jpg`;
  } else {
    return undefined;
  }
});

const dateRangeFormatted = computed(() => albumDateRangeFormat(props.album));

const randomInteger = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

// const    visibilityChanged = (isVisible: boolean) => {
//       isVisibleOnce.value = isVisibleOnce.value || isVisible;
//     }
</script>

<style lang="postcss">
.album-card {
  @apply no-underline;
  @apply bg-white rounded-lg shadow-md;
  @apply hover:bg-gray-200;
}

.album-card-photo {
  @apply rounded-t-lg h-64 object-cover w-full;
}

.album-card-title {
  @apply text-xl font-bold tracking-tight text-gray-900;
}
.album-card-text {
  @apply mb-3 font-normal text-gray-700;
}
</style>
